import React from 'react';
import { mockMembers } from '../../../services/mockData';

const SocietyMembers = () => (
  <div className="fade-in">
    <div className="page-header">
      <div className="breadcrumb">Society Reports <span>/ Society Members</span></div>
      <h2>Society Members Report</h2>
    </div>

    <div className="card">
      <div className="card-header">
        <span className="card-title">List Of Residential Members</span>
        <div className="btn-group">
          <button className="btn btn-warning btn-sm">🖨️ Print</button>
          <button className="btn btn-success btn-sm">📊 Export to Excel</button>
        </div>
      </div>

      <div className="report-header" style={{ marginBottom: '16px' }}>
        <h3>Vitthal Plaza Co-Op Housing Society LTD</h3>
        <p>Registration Number: TNADO(M/HSG/TC)/25796/YEAR-2023 | dr Sagar(Dombivali)</p>
        <p style={{ fontWeight: '700', marginTop: '6px' }}>Society Members Report 2025-2026 On dated: 2026-02-02</p>
      </div>

      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Flat</th>
              <th>Name</th>
              <th>Contact No</th>
              <th>Email</th>
              <th>Member Type</th>
            </tr>
          </thead>
          <tbody>
            {mockMembers.map((m, i) => (
              <tr key={i}>
                <td><span className="badge badge-primary">{m.flatNo}</span></td>
                <td style={{ fontWeight: '600' }}>{m.memberName}</td>
                <td>{m.contactNo}</td>
                <td style={{ fontSize: '12px', color: '#4361ee' }}>{m.email || '—'}</td>
                <td>
                  <span className={`badge ${
                    m.memberType === 'chairman' ? 'badge-primary' :
                    m.memberType === 'secretary' ? 'badge-success' :
                    m.memberType === 'autoclient' ? 'badge-warning' :
                    'badge-secondary'
                  }`}>
                    {m.memberType}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default SocietyMembers;
